import { Flex } from "@chakra-ui/react";
import React from "react";
import OutsideClickHandler from "react-outside-click-handler";


import { BrandWrapper, Container, NavigatorWrapper } from "./styles";

import { config } from "../../config/sidenav";
import Brand from "../Brand";
import Navigator from "../Navigator";
import OpenNavButon from "../OpenNavButon";
import Profile from "../Profile";

const Sidenav: React.FC = () => {
    const [open, setOpen] = React.useState(false);
    return (
        <OutsideClickHandler onOutsideClick={ () => setOpen(false) }>
            <Container open={ open }>
                <OpenNavButon open={ open } toggleHandler={ () => setOpen(!open) } />
                <Flex height="100%" flexDirection="column">
                    <BrandWrapper>
                        <Flex height="49px" borderBottom="1px" borderColor="gray.300">
                            <Brand></Brand>
                        </Flex>
                    </BrandWrapper>

                    <NavigatorWrapper>
                        <Profile />
                        <Navigator config={ config } />
                    </NavigatorWrapper>
                </Flex>
            </Container>
        </OutsideClickHandler>
    );
};

export default Sidenav;
